
import { Component, Prop, Vue, } from 'vue-property-decorator';
import ProgressSteps from '~/components/progress-steps/progress-steps.vue';

const progressStepsLabels = [
	'Your details',
	'Moving date',
	'Final bill',
	'Forwarding address',
	'Check and confirm',
];

@Component({
	components: {
		ProgressSteps,
	},
})
export default class PayBillProgressSteps extends Vue {
	@Prop({
		type: Number,
		required: true,
	})
	currentStep!: number;

	progressStepsLabels = progressStepsLabels;
}
